import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
import FacebookIcon from '@mui/icons-material/Facebook';
import EmailIcon from '@mui/icons-material/Email';

const Contact = () => {
  return (
    <>
      <Helmet>
        <title>Contact Us - Mirmire</title>
        <meta name="description" content="Get in touch with Mirmire SC" />
      </Helmet>

      {/* Header Section with Logo */}
      <Box
        sx={{
          bgcolor: '#000000',
          py: { xs: 6, md: 8 },
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography
          variant="h1"
          sx={{
            color: '#FFD700',
            fontWeight: 700,
            fontSize: { xs: '2.5rem', md: '3.5rem' },
            textAlign: 'center',
          }}
        >
          CONTACT US
        </Typography>
      </Box>

      {/* Social Media and Contact Section */}
      <Box
        sx={{
          bgcolor: '#FFFFFF',
          py: 8,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            width: '1000px',
            display: 'flex',
            justifyContent: 'center',
            gap: 8,
            px: 2,
          }}
        >
          <a
            href="https://facebook.com/mirmiresc"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'inherit', textDecoration: 'none' }}
          >
            <FacebookIcon sx={{ fontSize: '4rem', color: '#000000' }} />
          </a>
          <a href="mailto:mirmiresc@gmail.com" style={{ color: 'inherit', textDecoration: 'none' }}>
            <EmailIcon sx={{ fontSize: '4rem', color: '#000000' }} />
          </a>
        </Box>
      </Box>

      {/* Email Display */}
      <Box
        sx={{
          bgcolor: '#FFFFFF',
          pb: 8,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: '#000000',
            fontSize: '1.5rem',
            fontWeight: 500,
          }}
        >
          mirmiresc@gmail.com
        </Typography>
      </Box>

      {/* Membership CTA Section */}
      <Box
        sx={{
          bgcolor: '#FFFFFF',
          py: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 4,
          borderTop: '1px solid #E0E0E0',
        }}
      >
        <Typography
          variant="h2"
          sx={{
            color: '#DAA520',
            fontWeight: 700,
            fontSize: { xs: '2rem', md: '2.5rem' },
            textAlign: 'center',
            maxWidth: '800px',
            px: 2,
          }}
        >
          WANT TO BECOME A MEMBER OF THE CLUB?
        </Typography>
        <Button
          variant="outlined"
          component={RouterLink}
          target="_blank"
          to="https://forms.gle/uEmTRY5npc2L8Uj89"
          sx={{
            color: '#000000',
            borderColor: '#000000',
            borderWidth: 2,
            px: 6,
            py: 1,
            fontSize: '1.25rem',
            fontWeight: 600,
            '&:hover': {
              borderWidth: 2,
              borderColor: '#DAA520',
              color: '#DAA520',
            },
          }}
        >
          JOIN NOW
        </Button>
      </Box>
    </>
  );
};

export default Contact;
